// extracted by mini-css-extract-plugin
export default {"root":"RegistryItem_root_HVi_6","selected":"RegistryItem_selected_PiTN1"};